/** Call signaling helpers (REST polling — matches the rest of the app). */
import api from "@/lib/api";

export const rtcConfig = () => api.get("/chat/rtc-config").then((r) => r.data);
export const startCall = (conversationId, kind) =>
  api.post("/chat/calls", { conversation_id: conversationId, kind }).then((r) => r.data);
export const fetchActiveCalls = () => api.get("/chat/calls/active").then((r) => r.data);
export const acceptCall = (id) => api.post(`/chat/calls/${id}/accept`).then((r) => r.data);
export const declineCall = (id) => api.post(`/chat/calls/${id}/decline`).then((r) => r.data);
export const leaveCall = (id) => api.post(`/chat/calls/${id}/leave`).then((r) => r.data);
export const sendSignal = (id, to, type, payload) =>
  api.post(`/chat/calls/${id}/signal`, { to, type, payload }).then((r) => r.data);
export const pollSignals = (id, since) =>
  api.get(`/chat/calls/${id}/signal`, { params: { since } }).then((r) => r.data);

/** Ask the CallManager (mounted in Dashboard) to start a call. */
export const requestCall = (conversationId, kind, convoName) =>
  window.dispatchEvent(new CustomEvent("em:start-call", { detail: { conversationId, kind, convoName } }));
